import { jwtDecode } from "jwt-decode";

export function isTokenExpired(token: string): boolean {
  const decoded: any = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
}
